import { EMPTY_FUNCTION, EMPTY_LIST } from '../../../../constants/common'
import { RentalPortalProfileHeaderFooterAddNewText } from '../RentalPortalProfileHeaderFooterAddNewText'
import { RentalPortalProfileHeaderFooterMoreButton } from '../RentalPortalProfileHeaderFooterMoreButton'

import * as styles from './RentalPortalProfileHeaderFooterHiddenMeasureLayer.module.css'

function RentalPortalProfileHeaderFooterHiddenMeasureLayer({
  addNewTextMeasureRef,
  moreButtonMeasureRef,
}) {
  return (
    <>
      <div className={styles.measureLayer} ref={addNewTextMeasureRef}>
        <RentalPortalProfileHeaderFooterAddNewText />
      </div>
      <div className={styles.measureLayer} ref={moreButtonMeasureRef}>
        <RentalPortalProfileHeaderFooterMoreButton
          blocked
          buttonClassName={styles.measureButton}
          options={EMPTY_LIST}
          onSelectItem={EMPTY_FUNCTION}
        />
      </div>
    </>
  )
}

export default RentalPortalProfileHeaderFooterHiddenMeasureLayer
